var ident = function(a) {return a;};

var HashMap = function(hash) {
    this._content = new Map();
    this._hash = hash || ident;
};

var Pair = function(key, val) {
    this.key = key;
    this.val = val;
};

//are the map items stored in pair objects?
//may be overrided by classes that inherit form HashMap
HashMap.prototype.usePair = function() {
    return this._hash != ident;
};

HashMap.prototype._castItemToPair = function(item) {
    if(this.usePair())
        return item[1];
    else
        return new Pair(item[0], item[1]);
};

HashMap.prototype.put = function(key, val){
    if (key == undefined) return;
    if(this.usePair()) {
        var hash = this._hash(key);
        this._content.set(hash, new Pair(key, val));
    } else {
        this._content.set(key, val);
    }
};

HashMap.prototype.putAll = function(map){
    var self = this;
    map.forEach(function(key, value) {
        self.put(key, value);
    });
};

HashMap.prototype.get = function(key){
    if (key == undefined) return;
    if(this.usePair()) {
        var hash = this._hash(key);
        if(!this._content.has(hash))
            return undefined;
        else
            return this._content.get(hash).val;
    } else {
        return this._content.get(key);
    }
};

HashMap.prototype.getOne = function(){
    for (var item of this._content) {
        var pair = this._castItemToPair(item);
        return pair.val;
    }
};

HashMap.prototype.size = function(){
    return this._content.size;
};

HashMap.prototype.isEmpty = function(){
    return this._content.size === 0;
};

HashMap.prototype.contains = function(key){
    if (key == undefined) return false;
    var hash = this._hash(key);
    return this._content.has(hash);
};

HashMap.prototype.containsAll = function(keySet){
    var self = this;
    var result = true;
    keySet.forEach(function(key){
        if (!self.contains(key)) result = false;
    });
    return result;
};

HashMap.prototype.containsValue = function(val){
    for (var item of this._content) {
        var pair = this._castItemToPair(item);
        if (pair.val == val) return true;
    }
    return false;
};

HashMap.prototype.forEach = function(f){
    var initialLength = this.size();
    for (var item of this._content) {
        var pair = this._castItemToPair(item);
        f(pair.key, pair.val);
        console.assert(this.size() == initialLength, "Don't change the content of a collection while iterating (forEach)"); // assertion in hot loop! check performance impact
    }
};

HashMap.prototype.forEachPair = function(f, includeEquals){
    var visited = new HashMap();
    this.forEach(function(k0, v0){
        if (includeEquals) visited.put(k0, v0);
        visited.forEach(function(k1, v1){
            f(k0, v0, k1, v1);
        });
        if (!includeEquals) visited.put(k0, v0);
    });
};

HashMap.prototype.remove = function(key){
    if (key == undefined) return;
    if(this.usePair()) {
        var hash = this._hash(key);
        if (this._content.has(hash)) {
            var pair = this._content.get(hash);
            this._content.delete(hash);
            return pair.val;
        }
    } else {
        if (this._content.has(key)) {
            var val = this._content.get(key);
            this._content.delete(key);
            return val;
        }
    }
};

HashMap.prototype.removeAll = function(col){
    var self = this;
    var toBeRemoved = (col == undefined || col == this) ? this.copy() : col;
    toBeRemoved.forEach(function(key){
        self.remove(key);
    });
};

HashMap.prototype.removeWhere = function(f){
    this.removeAll(this.filter(f));
};

HashMap.prototype.removeValue = function(val){
    this.removeWhere(function(k, v){
        return v == val;
    });
};

HashMap.prototype.copy = function() {
    var result = new HashMap(this._hash);
    result.putAll(this);
    return result;
};

HashMap.prototype.filter = function(f){
    var result = new HashMap(this._hash);
    this.forEach(function(key, val){
        if (f(key, val)) result.put(key, val);
    });
    return result;
};

HashMap.prototype.map = function(f){
    var result = new HashMap(this._hash);
    this.forEach(function(key, val){
        result.put(key, f(key, val));
    });
    return result;
};

HashMap.prototype.reduce = function(f, initialValue){
    var result = initialValue != undefined ? initialValue : 0;
    this.forEach(function(key, val){
        result = f(result, key, val);
    });
    return result;
};

HashMap.prototype.getMin = function(compare){ // compare function should return negative number when a < b, return 0 when a = b, return positive number when a > b
    if (!compare) compare = function(a,b){return a<b? -1: a>b? 1:0;};   // Remark default compare: if values cannot be compared with '<' and '>', min will be unpredictable. E.g. objects, mix of numbers and strings
    var min;
    for (var item of this._content) {
        var pair = this._castItemToPair(item);
        if (min == undefined) min = pair.val;
        else if (compare(pair.val, min) < 0) min = pair.val;
    }
    return min;
};

HashMap.prototype.getMax = function(compare){
    if (!compare) compare = function(a,b){return a<b? -1: a>b? 1:0;};
    var max;
    for (var item of this._content) {
        var pair = this._castItemToPair(item);
        if (max == undefined) max = pair.val;
        else if (compare(pair.val, max) > 0) max = pair.val;
    }
    return max;
};

HashMap.prototype.find = function(f){
    for (var item of this._content) {
        var pair = this._castItemToPair(item);
        if (f(pair.key, pair.val)) return pair.val;
    }
};

HashMap.prototype.some = function(f) {
    for (var item of this._content) {
        var pair = this._castItemToPair(item);
        if (f(pair.key, pair.val)) return true;
    }
    return false;
};

HashMap.prototype.every = function(f) {
    for (var item of this._content) {
        var pair = this._castItemToPair(item);
        if (!f(pair.key, pair.val)) return false;
    }
    return true;
};

HashMap.prototype.equals = function(map, compare){
    if(this.size() !== map.size()) return false;
    if(!compare) compare = function(a, b) { return a == b; };
    return this.every(function(key, val){
        return map.contains(key) && compare(val, map.get(key));
    });
};

HashMap.prototype.getKeysForValue = function(val){
    var result = []; // TODO: should return HashSet, since no order is defined for elements in map
    this.forEach(function (k,v) {
        if(v == val) result.push(k);
    });
    return result;
};

HashMap.prototype.values = function(){
    var result = []; // TODO: should return something else?
    this.forEach(function (k,v) {
        result.push(v);
    });
    return result;
};

HashMap.prototype.keys = function(){
    var result = []; // TODO: should return HashSet
    this.forEach(function (k,v) {
        result.push(k);
    });
    return result;
};

module.exports = HashMap;
